import React, { useCallback, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TEAM_MEMBERS } from '../data/teamMembers';
import TeamMemberCard from '../components/widgets/TeamMemberCard';

const MeetTheTeam = () => {
  const { t } = useTranslation();
  const [hoveredId, setHoveredId] = useState(null);
  const [pinnedId, setPinnedId] = useState(null);
  const [isMinMd, setIsMinMd] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(min-width: 768px)').matches
  );

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 768px)');
    const syncLayout = () => {
      const matches = mq.matches;
      setIsMinMd(matches);
      if (!matches) setHoveredId(null);
    };
    syncLayout();
    mq.addEventListener('change', syncLayout);
    return () => mq.removeEventListener('change', syncLayout);
  }, []);

  const isExpanded = useCallback(
    (id) => hoveredId === id || pinnedId === id,
    [hoveredId, pinnedId]
  );

  const handleHoverStart = useCallback((id) => setHoveredId(id), []);
  const handleHoverEnd = useCallback(() => setHoveredId(null), []);
  const handleToggleExpand = useCallback((id) => {
    setPinnedId((prev) => (prev === id ? null : id));
  }, []);

  const focusId = hoveredId ?? pinnedId;
  const hasRowFocus = isMinMd && focusId != null;

  return (
    <div className="team-page flex min-h-0 flex-1 flex-col w-full bg-canvas">
      <div className="flex min-h-0 flex-1 flex-col w-full px-4 py-6 sm:px-6 sm:py-8 lg:px-10 xl:px-14">
        <header className="relative z-10 mb-4 shrink-0 bg-canvas text-center sm:mb-5">
          <h1 className="text-3xl font-bold text-ink">{t('meetTheTeam.title')}</h1>
          <p className="mx-auto mt-2 max-w-3xl text-ink-muted">{t('meetTheTeam.subtitle')}</p>
          <p className="mx-auto mt-2 max-w-3xl text-sm text-ink-subtle">
            <Trans
              i18nKey="meetTheTeam.fundingNotice"
              components={{
                atlLink: (
                  <a
                    href="https://www.atlab.hku.hk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-link hover:text-link-hover no-underline"
                  />
                ),
              }}
            />
          </p>
        </header>

        <div className="team-row flex min-h-0 flex-1 flex-col items-stretch gap-10 overflow-y-auto pb-2 md:flex-row md:items-start md:gap-4 md:overflow-hidden lg:gap-6">
            {TEAM_MEMBERS.map((member) => (
              <TeamMemberCard
                key={member.id}
                member={member}
                isExpanded={isExpanded(member.id)}
                isFocused={member.id === focusId}
                hasRowFocus={hasRowFocus}
                onHoverStart={isMinMd ? handleHoverStart : undefined}
                onHoverEnd={isMinMd ? handleHoverEnd : undefined}
                onToggleExpand={handleToggleExpand}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default MeetTheTeam;
